import { QueryHookOptions, useMutation, useQuery } from '@apollo/client';
import {
  DOWNLOAD_CSV,
  DOWNLOAD_CSV_JOB_FOR_MEDIA_ONLINE,
  DOWNLOAD_SUMMARY_ONLINE_MEDIA,
  DOWNLOAD_SUMMARY_REPORT
} from './graphql/download/mutation';
import {
  DownloadSummaryReportResponse,
  DownloadSummaryReportPayload,
  GetSummaryReportListPayload,
  GetSummaryReportListResponse
} from 'src/models/download';
import { GET_SUMMARY_REPORT_STATUS_LIST } from './graphql/download/query';

const useDownload = () => {
  const [downloadCsv, resDownloadCsv] = useMutation(DOWNLOAD_CSV);
  const [downloadCsvMediaOnline, resDownloadCsvMediaOnline] = useMutation(
    DOWNLOAD_CSV_JOB_FOR_MEDIA_ONLINE
  );
  const [downloadSummaryOnlineMedia, resDownloadSummaryOnlineMedia] =
    useMutation(DOWNLOAD_SUMMARY_ONLINE_MEDIA);

  const [downloadSummaryReport, resDownloadSummaryReport] = useMutation<
    DownloadSummaryReportResponse,
    DownloadSummaryReportPayload
  >(DOWNLOAD_SUMMARY_REPORT, {
    refetchQueries: [GET_SUMMARY_REPORT_STATUS_LIST]
  });

  const useGetSummaryReportList = (
    options: QueryHookOptions<
      GetSummaryReportListResponse,
      GetSummaryReportListPayload
    >
  ) => {
    return useQuery<GetSummaryReportListResponse, GetSummaryReportListPayload>(
      GET_SUMMARY_REPORT_STATUS_LIST,
      options
    );
  };

  return {
    downloadCsv,
    resDownloadCsv,
    downloadCsvMediaOnline,
    resDownloadCsvMediaOnline,
    downloadSummaryOnlineMedia,
    resDownloadSummaryOnlineMedia,
    downloadSummaryReport,
    resDownloadSummaryReport,
    useGetSummaryReportList
  };
};

export default useDownload;
